<template>
  <div class="cartIcon" @click="gotoShoppingHandler">
    <font-awesome-icon :icon="['fas', 'shopping-cart']" />
    <span v-show="cartLength > 0">
      {{ cartLength }}
    </span>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState(['cartLength']),
  },
  methods: {
    gotoShoppingHandler() {
      if (this.cartLength <= 0) {
        this.$fire({
          title: '請先購物',
          type: 'error',
          timer: 3000,
        });
        this.$router.push({ name: 'products' });
        return;
      }
      this.$router.push({ name: 'shopping' });
    },
  },
};
</script>

<style lang="scss" scoped>
.cartIcon {
  font-size: 36px;
  text-align: center;
  position: fixed;
  right: 70px;
  bottom: 50px;
  color: #81c1ca;
  padding: 10px;
  z-index: 10;
  cursor: pointer;
  span {
    position: absolute;
    font-size: 24px;
    top: -5px;
    right: -10px;
    color: #000;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background-color: #81c1ca;
  }
  @media (max-width: 768px) {
    right: 20px;
  }
}
</style>
